<script setup lang="ts">
import { Head } from '@inertiajs/vue3'

import NotificationList from '@/components/notifications/NotificationList.vue'
import PortalLayout from '@/layouts/PortalLayout.vue'
import {
  destroyAllPortalOrganizationNotificationsPath,
  portalOrganizationNotificationPath,
  readAllPortalOrganizationNotificationsPath,
  readPortalOrganizationNotificationPath,
} from '@/routes'
import type { Notification } from '@/types'

defineProps<{ notifications: Notification[] }>()
</script>

<template>
  <Head title="Notifications" />
  <PortalLayout actor-type="organization">
    <NotificationList
      :notifications="notifications"
      :read-path="(id: number) => readPortalOrganizationNotificationPath(id)"
      :read-all-path="readAllPortalOrganizationNotificationsPath()"
      :delete-path="(id: number) => portalOrganizationNotificationPath(id)"
      :delete-all-path="destroyAllPortalOrganizationNotificationsPath()"
    />
  </PortalLayout>
</template>
